/* global Blockly */
import React from 'react';
import {getFormsFromContext} from "../../helpers";

function defineBlock(context) {
    const forms = getFormsFromContext(context);

    return {
        init: function () {
            this.appendDummyInput()
                .appendField("sync form")
                .appendField(new Blockly.FieldDropdown(forms), "FORMSLUG");
            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
            this.setColour(Blockly.Msg.APP_ACTIONS_HUE);
            this.setTooltip('Reset a form or a screen in the application.');
            this.setHelpUrl(Blockly.BASE_HELP_URL + "#app-actions");
        }
    }
}

function defineGenerators() {
    return {
        "JavaScript": function (block) {
            let formSlug = block.getFieldValue('FORMSLUG');
            let formFields = formSlug.split("<<<>>>");
            let formDataGenyId = formFields[0];
            let pageId = formFields[1];

            let code = `
                BlocklyPromises.push(actionsModule.getExecuteActionPromise({
                    action: {
                        actionType: "sync"
                    },
                    formDataGenyId: "${formDataGenyId || pageId}",
                }))
            `;

            return code;
        }
    }
}

const Sync = function (props) {
    let name = "snap_action_sync";
    Sync.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);

    let generators = defineGenerators(props.context);
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    if (!getFormsFromContext(props.context).length) {
        return null;
    }

    return (
        <block type={name}></block>
    );
};

export default Sync;
